export default [
    {
        path: "/not-authorized",
        name: "not-authorized",
        component: () => import("@/views/error/NotAuthorized.vue"),
        meta: {
            layout: "full",
            title: "Not Authorized - Leechall.io",
        },
    },
    {
        path: "/banned",
        name: "banned",
        component: () => import("@/views/error/Banned.vue"),
        meta: {
            layout: "full",
            title: "Banned - Leechall.io",
        },
    },
    {
        path: "/error-404",
        name: "error-404",
        component: () => import("@/views/error/Error404.vue"),
        meta: {
            layout: "full",
            title: "Page Not Found - Leechall.io",
        },
    },
    {
        path: "/wrong-ip-download",
        name: "wrong-ip-download",
        component: () => import("@/views/error/WrongIpDownload.vue"),
        meta: {
            layout: "full",
            title: "Wrong IP - Leechall.io",
        },
    },
    {
        path: "/under-maintenance",
        name: "under-maintenance",
        component: () => import("@/views/error/UnderMaintenance.vue"),
        meta: {
            layout: "full",
            title: "Under Maintenance - Leechall.io",
        },
    },
    {
        path: "*",
        redirect: "error-404",
    },
];
